module.exports = __webpack_public_path__ + "img/shakeys_hero.020af31f.png";